import { useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Form, InputGroup } from "react-bootstrap";

const PostComment = (props) => {
  const { postComment } = props;
  const params = useParams();
  const [formData, setFormData] = useState({
    id: params.id,
    text: "",
  });

  const onSubmit = (e) => {
    e.preventDefault();

    postComment(formData);

    setFormData({
      ...formData,
      text: "",
    });
  };

  return (
    <Form>
      <InputGroup className="mb-3 border-gray rounded">
        <Form.Control
          className="border-0"
          placeholder="Comment…"
          aria-label="Comment…"
          value={formData.text}
          onChange={(e) => setFormData({ ...formData, text: e.target.value })}
        />
        <div
          className="d-flex align-items-center m-2 text-primary-danger"
          onClick={(e) => onSubmit(e)}
        >
          Post
        </div>
      </InputGroup>
    </Form>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  postComment: dispatch.FeedsSM.postComment,
});

export default connect(mapStateToProps, mapDispatchToProps)(PostComment);
